import { render, staticRenderFns } from "./ConsultationBanner.vue?vue&type=template&id=50657fc6&lang=pug&"
import script from "./ConsultationBanner.vue?vue&type=script&lang=ts&"
export * from "./ConsultationBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports